import { Staff } from 'types/Staff';

export interface StaffsState {
    staffs: Array<Staff>;
    status: StaffStatus;
    loading: boolean;
}

export enum StaffStatus {
    Initial,

    Fetching,
    FetchSuccess,

    Error
}
